<div
  #rootEl
  class="pointer-events-none absolute inset-0 -z-10 bg-radial opacity-0"
  [class]="{
    'from-emerald-500/0': color() === 'emerald',
    'to-emerald-500/50': color() === 'emerald',
    'from-orange-500/0': color() === 'orange',
    'to-orange-500/50': color() === 'orange',
    'from-red-500/0': color() === 'red',
    'to-red-500/50': color() === 'red',
  }"
></div>
